/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

import { WidgetDateRange } from './widgetDateRange.zod'

export const logsListWidgetConfigLimitDefault = 50
export const logsListWidgetConfigLimitMax = 100

export const logsListWidgetConfigOrderByDefault = `latest`
export const logsListWidgetConfigWrapLinesDefault = false
export const logsListWidgetConfigTimezoneDefault = `UTC`

export const LogsListWidgetConfig = /* @__PURE__ */ zod.object({
    dateRange: zod.union([WidgetDateRange, zod.null()]).optional(),
    limit: zod
        .number()
        .min(1)
        .max(logsListWidgetConfigLimitMax)
        .default(logsListWidgetConfigLimitDefault)
        .describe('Maximum number of log lines to return.'),
    orderBy: zod
        .enum(['latest', 'earliest'])
        .default(logsListWidgetConfigOrderByDefault)
        .describe('Sort by newest (latest) or oldest (earliest) first.'),
    severityLevels: zod
        .array(zod.enum(['trace', 'debug', 'info', 'warn', 'error', 'fatal']))
        .optional()
        .describe('Only show logs at these severity levels. Empty shows all levels.'),
    serviceNames: zod
        .array(zod.string())
        .optional()
        .describe('Only show logs from these services. Empty shows all services.'),
    wrapLines: zod
        .boolean()
        .default(logsListWidgetConfigWrapLinesDefault)
        .describe('Wrap long log lines instead of truncating them to a single row.'),
    timezone: zod
        .enum(['UTC', 'local'])
        .default(logsListWidgetConfigTimezoneDefault)
        .describe("Render log timestamps in UTC or in each viewer's local timezone."),
    savedViewId: zod
        .union([zod.string(), zod.null()])
        .optional()
        .describe(
            'short_id of a saved logs view to use as the source. When set, the saved view owns the date range, severity, service, and property filters; only orderBy and limit still apply.'
        ),
})

export type LogsListWidgetConfig = zod.input<typeof LogsListWidgetConfig>
export type LogsListWidgetConfigOutput = zod.output<typeof LogsListWidgetConfig>
